import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { IUnit } from "../services/unitService";
import { Preferences } from "@capacitor/preferences";

export const UNIT_STORAGE_NAME = "unit-storage";

interface UnitState {
  units: IUnit[];
  currentPage: number;
  isLoading: boolean;
  isInitialLoaded: boolean;
  moreDataAvailable: boolean;
  viewType: "grid" | "list";
  setUnits: (units: IUnit[]) => void;
  setCurrentPage: (page: number) => void;
  setIsLoading: (isLoading: boolean) => void;
  setIsInitialLoaded: (isInitialLoaded: boolean) => void;
  setMoreDataAvailable: (moreData: boolean) => void;
  setViewType: (viewType: "grid" | "list") => void;
  reset: () => void;
}

const capacitorPreferencesStorage = {
  getItem: async (key: string) => {
    const { value } = await Preferences.get({ key });
    return value ?? null;
  },
  setItem: (key: string, value: string) => {
    return Preferences.set({ key, value });
  },
  removeItem: (key: string) => {
    return Preferences.remove({ key });
  },
};

const useUnitStore = create<UnitState>()(
  devtools(
    persist(
      (set) => ({
        units: [],
        currentPage: 1,
        isLoading: true,
        isInitialLoaded: false,
        moreDataAvailable: true,
        viewType: "grid",
        setUnits: (units: IUnit[]) => set({ units }),
        setCurrentPage: (page: number) => set({ currentPage: page }),
        setIsLoading: (isLoading: boolean) => set({ isLoading: isLoading }),
        setIsInitialLoaded: (isInitialLoaded: boolean) =>
          set({ isInitialLoaded: isInitialLoaded }),
        setMoreDataAvailable: (moreData: boolean) =>
          set({ moreDataAvailable: moreData }),
        setViewType: (viewType: "grid" | "list") =>
          set({ viewType: viewType }),
        reset: () => {
          set({
            units: [],
            isLoading: true,
            isInitialLoaded: false,
            viewType: "grid",
          });
        },
      }),
      {
        name: UNIT_STORAGE_NAME,
        storage: createJSONStorage(() => capacitorPreferencesStorage),
      }
    )
  )
);

export default useUnitStore;
